import React, { useState, useRef } from 'react'
import { Swiper } from 'swiper/react'
import SwiperCore from 'swiper'
import styled from 'styled-components'

import LegacyButton from 'components/LegacyButton'

import { Keyboard, Pagination, Navigation } from 'swiper/modules'

import { color } from 'styles/colors'

type Props={
  children: React.ReactNode;
  finishCallback: () => void
}

const Carousel = ({ children, finishCallback }: Props) => {
  const swiperRef = useRef<SwiperCore>()
  const [isEnd, setIsEnd] = useState(false)

  return (
    <Swiper
      spaceBetween={30}
      pagination={{
        clickable: true
      }}
      keyboard={{
        enabled: true
      }}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper
      }}
      onAfterInit={(swiper) => {
        setIsEnd(swiper.isEnd)
      }}
      onActiveIndexChange={(e) => {
        setIsEnd(e.isEnd)
      }}
      modules={[Keyboard, Pagination, Navigation]}
      className="Carousel"
    >
      {children}
      <S.ButtonContainer>
        <S.CancelButton type="button" variant="secondary" onClick={finishCallback} >Finish</S.CancelButton>
        <LegacyButton disabled={isEnd} onClick={() => swiperRef.current?.slideNext()} type="button" variant="primary">Next</LegacyButton>
      </S.ButtonContainer>
    </Swiper>
  )
}

export default Carousel

const S = {
  ButtonContainer: styled.div`
    display: flex;
    justify-content: end;
    gap: 10px;
    position: relative;
    z-index: 100;
    float: right;
  `,
  CancelButton: styled(LegacyButton)`
    border-color:  ${color('cancelButtonBorder')};
    color:  ${color('cancelButtonText')};

    &:hover{
      border-color:  ${color('cancelButtonHoverBorder')};
      color:  ${color('cancelButtonHoverText')};
    }
  `
}
